import { render, staticRenderFns } from "./CreateVirtualDataForm.vue?vue&type=template&id=73103fd8"
import script from "./CreateVirtualDataForm.vue?vue&type=script&lang=js"
export * from "./CreateVirtualDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports